<template>
    <div>
        <div v-show = "editField == false">
            <label @dblclick = "editField = true"> {{titleField}} </label>
        </div>
        <input v-show = "editField == true" v-model = "titleField"
        v-on:blur= "editField=false;"
        @keyup.enter = "editField=false; editTodo()">
    </div>
</template>
<script>
import Axios from 'axios';
export default {
    props: [
        'edit',
        'title',
        'url',
        'method',
        'field'
    ],
    data () {
        return {
            titleField: this.title || '-',
            editField: this.edit || false,
        }
    },
    methods: {
        editTodo: function() {
            Axios( {
                method: this.method,
                url: this.url,
                data: {
                    [this.field]: this.titleField,
                }
            })
        },
    }
}
</script>
